export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.itcsf.in/api"
export const NODE_ENV = process.env.NODE_ENV || 'production';
export const ACCESS_TOKEN_KEY = process.env.REACT_APP_ACCESS_TOKEN_KEY || "itcsf_access_token";
export const REFRESH_TOKEN_KEY = process.env.REACT_APP_REFRESH_TOKEN_KEY || "itcsf_refresh_token";
export const MEDIA_BASE_URL = process.env.REACT_APP_MEDIA_BASE_URL || " https://api.itcsf.in/uploads";